import axiosInstance from "../AxiosInstance";
import {
  ACTIVATE_ACCOUNT_API,
  CHANGEE_IMAGE_ORDER,
  DELETE_CONVERSATION,
  DISABLE_USER_DEVICE,
  ENABLE_USER_DEVICE,
  FORCE_VERIFICATION,
  FQA_CATEGORY_LIST,
  FQA_CATEGORY_ORDER,
  FQA_LIST,
  FQA_LIST_ORDER,
  FQA_SUBCATEGORY_LIST,
  GET_CHAT_MESSAGES,
  GET_CONVERSATION_LIST,
  GET_OTP_USER,
  GRAPH_DATA,
  HIDE_PROFILE_API,
  POSTS,
  RECOVER_ACCOUNT_API,
  REDEEM_LIST,
  REFFERAl_LIST,
  REMOVE_IMAGES,
  REMOVE_VOICE_NOTE,
  REPORTS_LIST,
  REUPLOAD_PROFILE_IMAGE,
  SEND_FORCE_UPDATE,
  SEND_MESSAGES,
  SEND_NOTIFICATION_FEMALE,
  SUPPORTLIST,
  TOGGLE_AUTO_APPROVE,
  UPDATE_BASIC_DETAILS,
  UPDATE_PREMIUM,
  UPLOAD_VARIFICATION_IMAGE,
  USERLIST,
  USERLISTPREMIUM,
  SUBSCRIPTIONS,
  USERLIST_EXPORT,
  USERLIST_HARD,
  USER_DETAILS,
  LEAD_QUALITY,
  USER_REFERRAL_AMOUNT,
  USER_REFERRAL_LIST,
  VERIFICATION_LIST,
  VERIFY_MULTIPLE,
  VIP_PREMIUM,
  VIP_UNLOCKED,
  WITHDRAWAL_REQUESTS,
  SINGLE_USER_REPORTS,
  INTERNAL_USER,
  DELETE_CONVERSATION_ALL,
  FOLLOW_UP,
  FORCE_ID_VERIFICATION,
  GET_IDS_USERS,
  WARNING_IMAGE,
  BLOCK_USER,
  BLOCK_CONVERSATION_MESSAGE,
  LOCK_IMAGE,
  REPORTS_LIST_DETAILS,
  UPLOAD_VARIFICATION_VOICE,
  FAVOURITE_ALL_USERS,
  LOCK_IMAGE_NOTIFICATION,
  SEND_IMAGE_REQUEST_FEMALE,
  UPLOAD_PROFILE_IMAGES,
  VERIFICATION_IMAGES,
  REPLACE_FACE_VERIFICATION,
  INTERNAL_USER_REPLACE_IMAGE,
  REMOVE_USER_LIST_INTERNAL,
} from "./UserEndpoint";

// export function getUserList(
//   page,
//   limit,
//   search,
//   gender,
//   status,
//   isFormFilled,
//   signUpType,
//   startDate,
//   endDate
// ) {
//   return axiosInstance.get(
//     USERLIST +
//       `?page=${page}&limit=${limit}&search=${search}&gender=${gender}&userList=${status}&formFill=${isFormFilled}&loginType=${signUpType}&startDate=${startDate}&endDate=${endDate}`
//   );
// }
export function getUserList(
  page,
  limit,
  search,
  age,
  selectedCountry,
  gender,
  status,
  isFormFilled,
  signUpType,
  activeStatus,
  startDate,
  endDate,
  leadQuality
) {
  const params = new URLSearchParams({
    page: page,
    limit: limit,
    search: search,
    age: age,
    location: selectedCountry,
    gender: gender,
    userList: status,
    formFill: isFormFilled,
    loginType: signUpType,
    sortBy: activeStatus,
    isExport: false,
  });

  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }
  if (leadQuality && leadQuality !== "all") {
    params.append("leadQuality", leadQuality);
  }

  return axiosInstance.get(`${USERLIST}?${params.toString()}`);
}

export function getUserListInternal(
  page,
  limit,
  search,
  activeStatus
) {
  const params = new URLSearchParams({
    page: page,
    limit: limit,
    search: search,
    sortBy: activeStatus,
  });
  return axiosInstance.get(`${INTERNAL_USER}?${params.toString()}`);
}

export function getUserListInternalReplaceImage(
) {
  return axiosInstance.get(`${INTERNAL_USER_REPLACE_IMAGE}`);
}

export function getUserListSender(
  page,
  limit,
  search,
  gender,
  status,
  isFormFilled,
  signUpType,
  activeStatus,
  startDate,
  endDate
) {
  const params = new URLSearchParams({
    page: page,
    limit: limit,
    search: search,
    gender: gender,
    userList: status,
    formFill: isFormFilled,
    loginType: signUpType,
    sortBy: activeStatus,
    isExport: false,
  });

  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }

  return axiosInstance.get(`${USERLIST}?${params.toString()}`);
}

export function getUserListExport(
  search,
  gender,
  status,
  isFormFilled,
  signUpType,
  activeStatus,
  startDate,
  endDate,
  isExport,
  selectedIds
) {
  if (isExport) {
    const params = {
      search: search,
      gender: gender,
      userList: status,
      formFill: isFormFilled,
      loginType: signUpType,
      sortBy: activeStatus,
      userIds: selectedIds,
    };

    if (startDate) {
      params.append("startDate", startDate);
    }
    if (endDate) {
      params.append("endDate", endDate);
    }

    return axiosInstance.post(USERLIST_EXPORT, params);
  } else {
    const params = {
      search: search,
      gender: gender,
      userList: status,
      formFill: isFormFilled,
      loginType: signUpType,
      sortBy: activeStatus,
    };

    if (startDate) {
      params.append("startDate", startDate);
    }
    if (endDate) {
      params.append("endDate", endDate);
    }

    return axiosInstance.post(USERLIST_EXPORT, params);
  }
}

export function getUserListSenderMessage(
  page,
  limit,
  search,
  gender,
  status,
  isFormFilled,
  signUpType,
  activeStatus,
  startDate,
  endDate
) {
  const params = new URLSearchParams({
    page: page,
    limit: limit,
    search: search,
    gender: JSON.stringify(gender),
    userList: status,
    formFill: isFormFilled,
    loginType: JSON.stringify(signUpType),
    sortBy: activeStatus,
    isExport: false,
  });

  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }

  return axiosInstance.get(`${USERLIST}?${params.toString()}`);
}

export function getUserExportList() {
  return axiosInstance.get(`${USERLIST}?isExport=true`);
}

export function getPremiumUserList(
  page,
  limit,
  age,
  selectedCountry,
  type,
  status,
  search,
  filterByAdmin,
  // gender,
  // status,
  // isFormFilled,
  // signUpType,
  startDate,
  endDate,
  isPast
) {
  const params = new URLSearchParams({
    page: page,
    limit: limit,
    age: age,
    location: selectedCountry,
    type: type,
    search: search,
    filter: filterByAdmin,
    // gender:gender,
    userList: status,
    // formFill:isFormFilled,
    // loginType:signUpType,
    isPast: isPast,
  });

  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }

  return axiosInstance.get(`${USERLISTPREMIUM}?${params.toString()}`);
}

export function getCancelledSubscriptionsList(page, limit, search = "") {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  if (search) params.set("search", search);

  return axiosInstance.get(`${SUBSCRIPTIONS}?${params.toString()}`);
}

export function getUserDetails(id) {
  return axiosInstance.get(USER_DETAILS + `?userId=${id}`);
}

export function updateLeadQuality(userId, quality) {
  return axiosInstance.put(LEAD_QUALITY, { userId, quality });
}

export function updateImages(postData) {
  return axiosInstance.put(REMOVE_IMAGES, postData);
}

export function updatePremium(postData) {
  return axiosInstance.put(UPDATE_PREMIUM, postData);
}

export function updateVipPremium(postData) {
  return axiosInstance.put(VIP_PREMIUM, postData);
}

export function updateVipUnlocked(postData) {
  return axiosInstance.put(VIP_UNLOCKED, postData);
}

export function forceVerificationApi(postData) {
  return axiosInstance.post(FORCE_VERIFICATION, postData);
}

export function forceIdVerificationApi(postData) {
  return axiosInstance.put(FORCE_ID_VERIFICATION, postData);
}

export function internalUserApi(postData) {
  return axiosInstance.put(INTERNAL_USER, postData);
}

export function internalUserGetApi() {
  return axiosInstance.get(INTERNAL_USER);
}

export function removeVoiceNoteApi(postData) {
  return axiosInstance.delete(`${REMOVE_VOICE_NOTE}?userId=${postData.userId}`);
}

export function updateNonPremium(id) {
  const postData = { userId: id };
  return axiosInstance.put(UPDATE_PREMIUM, postData);
}

export function updateBasicDetails(postData) {
  return axiosInstance.put(UPDATE_BASIC_DETAILS, postData);
}

export function apiFavouriteAllUsers(id) {
  const postData = { userId: id };
  return axiosInstance.post(FAVOURITE_ALL_USERS, postData);
}

export function sendNotificationFemale(id, type) {
  const postData = { userId: id, sendTo: type };
  return axiosInstance.post(SEND_NOTIFICATION_FEMALE, postData);
}

export function sendImageRequestFemale(id) {
  const postData = { userId: id };
  return axiosInstance.post(SEND_IMAGE_REQUEST_FEMALE, postData);
}

export function activateAccountApi(id) {
  const postData = { userId: id };
  return axiosInstance.put(ACTIVATE_ACCOUNT_API, postData);
}

export function recoverAccountApi(id) {
  const postData = { userId: id };
  return axiosInstance.put(RECOVER_ACCOUNT_API, postData);
}

export function removeUserFromInternal(id) {
  const postData = { internalUserId: id };
  return axiosInstance.put(REMOVE_USER_LIST_INTERNAL, postData);
}

export function hideProfileApi(id) {
  const postData = { userId: id };
  return axiosInstance.put(HIDE_PROFILE_API, postData);
}

export function uploadImage(payload) {
  return axiosInstance.put(UPLOAD_VARIFICATION_IMAGE, payload);
}

export function uploadProfileImage(payload) {
  return axiosInstance.post(UPLOAD_PROFILE_IMAGES, payload);
}

export function uploadVoice(payload) {
  return axiosInstance.put(UPLOAD_VARIFICATION_VOICE, payload);
}

export function deleteConversation(payload) {
  return axiosInstance.post(DELETE_CONVERSATION, payload);
}

export function deleteConversationAll(id) {
  return axiosInstance.delete(DELETE_CONVERSATION_ALL + `?userId=${id}`);
}

export function getGraphData(type) {
  return axiosInstance.get(GRAPH_DATA + `?type=${type}`);
}

export function getOtpUser() {
  return axiosInstance.post(GET_OTP_USER);
}

export function deleteUser(id) {
  return axiosInstance.delete(USERLIST + `?userId=${id}`);
}

export function disableUserDevice(id) {
  const postData = { userId: id };
  return axiosInstance.post(DISABLE_USER_DEVICE, postData);
}

export function enableUserDevice(id) {
  const postData = { userId: id };
  return axiosInstance.post(ENABLE_USER_DEVICE, postData);
}

export function deleteUserHard(id) {
  return axiosInstance.delete(USERLIST_HARD + `?userId=${id}`);
}

export function blockUser(id) {
  const postData = { userId: id };
  return axiosInstance.put(USERLIST, postData);
}

export function warningImageApi(id) {
  const postData = { userId: id };
  return axiosInstance.post(WARNING_IMAGE, postData);
}

export function blockUserApi(id) {
  const postData = { userId: id };
  return axiosInstance.post(BLOCK_USER, postData);
}

export function blockConversationMessageApi(id) {
  const postData = { userId: id };
  return axiosInstance.post(BLOCK_CONVERSATION_MESSAGE, postData);
}

export function getVerificationRequests(
  page,
  limit,
  type,
  status,
  gender,
  order
) {
  return axiosInstance.get(
    VERIFICATION_LIST +
    `?page=${page}&limit=${limit}&type=${type}&filter=${status}&gender=${gender}&filterByOrder=${order}`
  );
}

export function getProfileImageVerificationRequests(
  page,
  limit,
  isRejected,
  // type,
  // status,
  gender,
  order,
  selectedCountry
) {
  return axiosInstance.get(
    REUPLOAD_PROFILE_IMAGE +
    `?page=${page}&limit=${limit}&gender=${gender}&filterByOrder=${order}&isRejected=${isRejected}&actualCountry=${selectedCountry ? selectedCountry : ""}`
  );
}

export function approveMultiRequest(formData) {
  return axiosInstance.put(VERIFY_MULTIPLE, formData);
}
export function toggleAutoApprove(formData) {
  return axiosInstance.put(TOGGLE_AUTO_APPROVE, formData);
}
export function approveRejectRequest(formData) {
  return axiosInstance.put(VERIFICATION_LIST, formData);
}
export function changeImageOrder(formData) {
  return axiosInstance.post(CHANGEE_IMAGE_ORDER, formData);
}

export function followUp(payload) {
  return axiosInstance.post(FOLLOW_UP, payload);
}
////////////////=====================report list==============/////////////////////////////////////

export function getReportList(page, limit) {
  return axiosInstance.get(REPORTS_LIST + `?page=${page}&limit=${limit}`);
}

export function getReportListDetails(id) {
  return axiosInstance.get(REPORTS_LIST_DETAILS + `?reportId=${id}`);
}
/////////////===================support======================//////////////////////////////////////

export function getSupportList(page, limit, search, sort, dataId) {
  return axiosInstance.get(
    SUPPORTLIST + `?page=${page}&limit=${limit}&search=${search}&sort=${sort == "search" ? "" : sort}&userId=${dataId ? dataId : ""}`
  );
}

export function UpdateSupportStatus(formdata) {
  return axiosInstance.put(SUPPORTLIST, formdata);
}

export function deleteSupport(id) {
  return axiosInstance.delete(SUPPORTLIST + `?ticketId=${id}`);
}

/////////////////////////================Refferal List========================////////////////////////

export function getRefferalList(
  page,
  limit,
  search,
  searchBy,
  sortBy,
  selectedTab
) {
  return axiosInstance.get(
    REFFERAl_LIST +
    `?page=${page}&limit=${limit}&search=${search}&searchBy=${searchBy}&sortOrder=${sortBy}&createdBy=${selectedTab}`
  );
}

export function createReferralCode(formData) {
  return axiosInstance.post(REFFERAl_LIST, formData);
}

export function deleteCode(id) {
  return axiosInstance.delete(REFFERAl_LIST + `?referralId=${id}`);
}

export function getRedeemedList(page, limit, type, id) {
  return axiosInstance.get(
    REDEEM_LIST + `?page=${page}&limit=${limit}&type=${type}&referralId=${id}`
  );
}

/////////////////////////================ Faqs   ===========================////////////////////////
export function getFaqsList(page, limit, id) {
  return axiosInstance.get(FQA_LIST + `?categoryId=${id}`);
}

export function createFaq(formData) {
  return axiosInstance.post(FQA_LIST, formData);
}

export function editFaq(formData) {
  return axiosInstance.put(FQA_LIST, formData);
}

export function deleteFaq(id, faqId) {
  return axiosInstance.delete(FQA_LIST + `?questionId=${id}&faqId=${faqId}`);
}
export function changeFaqOrder(formData) {
  return axiosInstance.put(FQA_LIST_ORDER, formData);
}

export function getFaqsCategory(page, limit) {
  return axiosInstance.get(FQA_CATEGORY_LIST + `?page=${page}&limit=${limit}`);
}

export function changeFaqCategoryOrder(formData) {
  return axiosInstance.put(FQA_CATEGORY_ORDER, formData);
}
export function createCategory(formData) {
  return axiosInstance.post(FQA_CATEGORY_LIST, formData);
}
export function sendMessageApi(formData) {
  return axiosInstance.post(SEND_MESSAGES, formData);
}
export function sendForceUpdate(formData) {
  return axiosInstance.put(SEND_FORCE_UPDATE, formData);
}
export function editCategory(formData) {
  return axiosInstance.put(FQA_CATEGORY_LIST, formData);
}
export function deleteFaqCategory(id) {
  return axiosInstance.delete(FQA_CATEGORY_LIST + `?categoryId=${id}`);
}

//////////////================subcategory============////////////////

export function getFaqsSubCategory(page, limit, categoryId) {
  return axiosInstance.get(
    FQA_SUBCATEGORY_LIST +
    `?page=${page}&limit=${limit}&categoryId=${categoryId}`
  );
}

export function createSubCategory(formData) {
  return axiosInstance.post(FQA_SUBCATEGORY_LIST, formData);
}

export function deleteFaqSubCategory(subCategoryId) {
  return axiosInstance.delete(
    FQA_SUBCATEGORY_LIST + `?subcategoryId=${subCategoryId}`
  );
}

//////////////////////======================withdrawal requests===========////////////////////////

export function getWithdrawalRequests(page, limit) {
  return axiosInstance.get(
    WITHDRAWAL_REQUESTS + `?page=${page}&limit=${limit}`
  );
}

export function withdrawalRequestAction(formData) {
  return axiosInstance.put(WITHDRAWAL_REQUESTS, formData);
}

export function getUserReferralList(page, limit, filterStatus, id) {
  return axiosInstance.get(
    USER_REFERRAL_LIST +
    `?page=${page}&limit=${limit}&type=${filterStatus}&userId=${id}`
  );
}
export function getPayNowList(id) {
  return axiosInstance.get(USER_REFERRAL_AMOUNT + `?referralId=${id}`);
}
export function payNow(formData) {
  return axiosInstance.put(USER_REFERRAL_AMOUNT, formData);
}

/////////////=============== posts===================//////////////////////

export function getPostList(page, limit) {
  return axiosInstance.get(POSTS + `?page=${page}&limit=${limit}`);
}
export function deletePost(id) {
  return axiosInstance.delete(POSTS + `?postId=${id}`);
}

export async function getConversationList(payload) {
  return axiosInstance.get(
    GET_CONVERSATION_LIST +
    `?userId=${payload.userId}&search=${payload.search}&filter=${payload.filter}&page=${payload.page}&limit=${payload.limit}`
  );
}

export async function getChatMessageList(conversationId) {
  return axiosInstance.get(
    GET_CHAT_MESSAGES + `?page=0&limit=1000&conversationId=${conversationId}`
  );
}

export function getSingleUserReports(userId) {
  return axiosInstance.get(SINGLE_USER_REPORTS + `?userId=${userId}`);
}

export function lockImage(payload) {
  return axiosInstance.put(LOCK_IMAGE, payload);
}

export function lockImageNotification(payload) {
  return axiosInstance.put(LOCK_IMAGE_NOTIFICATION, payload);
}

export function getIdsUsers(
  page,
  limit,
  search,
  age,
  selectedCountry,
  gender,
  status,
  isFormFilled,
  signUpType,
  activeStatus,
  startDate,
  endDate,
  leadQuality,
) {
  const params = new URLSearchParams({
    page: page,
    limit: limit,
    search: search,
    age: age,
    location: selectedCountry,
    gender: gender,
    userList: status,
    formFill: isFormFilled,
    loginType: signUpType,
    sortBy: activeStatus,
    isExport: false,
  });

  if (startDate) {
    params.append("startDate", startDate);
  }
  if (endDate) {
    params.append("endDate", endDate);
  }
  if (leadQuality && leadQuality !== "all") {
    params.append("leadQuality", leadQuality);
  }

  return axiosInstance.get(`${GET_IDS_USERS}?${params.toString()}`);
}

export function getVerificationImages(page, limit) {
  return axiosInstance.get(`${VERIFICATION_IMAGES}`);
}

export function replaceFaceVerification(internalUserId, faceVerificationUserId) {
  return axiosInstance.put(REPLACE_FACE_VERIFICATION, {
    internalUserId,
    faceVerificationUserId,
  });
}
